export default __webpack_public_path__ + "static/0251-e7e7779f8a8f1f00badb4fad4536d4f5.png";